import { render } from "./invitation.vue?vue&type=template&id=5c97be7e"
import script from "./invitation.vue?vue&type=script&lang=js"
export * from "./invitation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__